import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;

//获取clientopenid
export const getclientopenid = params => {
  return ax.gJson(URL + "/wxinf/getclientopenid", params);
};
//根据气瓶编号获取气瓶详情信息
export const getCylindersDetail = params => {
  return ax.pJson(URL + "/app/gzh/getCylindersDetail", params);
};

//获取轮播图
export const getBannerList = params => {
  return ax.pJson(URL + "/app/gzh/getBannerList", params);
};

//获取通知公告
export const getTzggList = params => {
  return ax.pJson(URL + "/app/gzh/getTzggList", params);
};

//根据pid获取通知公告
export const getTzggByPid = params => {
  return ax.pJson(URL + "/app/gzh/getTzggByPid", params);
};
//根据pid获取轮播图信息
export const getBannerByPid = params => {
  return ax.pJson(URL + "/app/gzh/getBannerByPid", params);
};

//根据手机号获取地址详情列表
export const getAddrDetailByTel = params => {
  return ax.pJson(URL + "/app/gzhorder/getAddrDetailByTel", params);
};

//获取气瓶类型列表
export const getgoodsType = params => {
  return ax.pJson(URL + "/app/gzhorder/getgoodsType", params);
};

//获取气瓶类型列表
export const insTOrder = params => {
  return ax.pJson(URL + "/app/gzhorder/insTOrder", params);
};

//发送验证码
export const sendmsm = params => {
  return ax.pJson(URL + "/app/gzhlogin/sendmsm", params);
};

//验证验证码
export const checkmsmyzm = params => {
  return ax.pJson(URL + "/app/gzhlogin/checkmsmyzm", params);
};

//判断openid是否存在
export const checkopenid = params => {
  return ax.pJson(URL + "/app/gzhlogin/checkopenid", params);
};

//绑定用户openid
export const updopenid = params => {
  return ax.pJson(URL + "/app/gzhlogin/updopenid", params);
};


// WEBPACK FOOTER //
// ./src/api/ZghApi/ZghAx.js